<template>
  <div class="main-bar">
    <div ref="layout" class="main-bar__layout" />

    <div :class="['main-bar__content container', { scrollable: mainBarIsScrollable }]">
      <div
        class="icon nav-toggler"
        @click="$nav.show()"
      >
        <f-sprite-icon :icon-link="$options.icons.IconNav" />
      </div>

      <a
        class="logo"
        href="/"
      >
        <f-sprite-icon :icon-link="$options.icons.IconLogo" />
      </a>

      <control-city />

      <control-subscriptions />

      <a
        class="link stores"
        href="/stores"
      >
        Магазины
      </a>

      <a
        class="link phone"
        href="tel:+78007700101"
      >
        8 800 770 01 01
      </a>

      <client-only>
        <div
          v-if="adaptive.isTablet"
          class="tablet-menu"
        >
          <tree-menu
            :items="MENU"
            :max-depth="1"
          />
        </div>

        <menu-icons location="main-bar" />
      </client-only>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/* Icons */
import IconNav from '@icons/nav-toggler.svg';
import IconLogo from '@images/logo.multi.svg';

import ControlCity from './control-city.vue';
import ControlSubscriptions from './control-subscriptions';
import MenuIcons from './menu-icons.vue';
import treeMenu from './tree-menu.vue';

export default {
  name: 'main-bar',

  components: {
    treeMenu,
    ControlCity,
    MenuIcons,
    ControlSubscriptions,
  },

  inject: ['adaptive'],

  icons: {
    IconLogo,
    IconNav,
  },

  data() {
    return {
      scrollableIsActive: false,
    };
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
    }),

    isScrollableHeaderTabletActive() {
      return this.adaptive.isTablet
        && this.$isFeatureEnabled(this.featuresEnum.SCROLLABLE_HEADER_TABLET);
    },

    isScrollableHeaderMobileActive() {
      return this.adaptive.isMobile
        && this.$isFeatureEnabled(this.featuresEnum.SCROLLABLE_HEADER_MOBILE);
    },

    mainBarIsScrollable() {
      return this.scrollableIsActive && (this.isScrollableHeaderTabletActive || this.isScrollableHeaderMobileActive);
    },
  },

  mounted() {
    this.startObserver();
    window.addEventListener('resize', this.startObserver, false);
  },

  beforeUnmount() {
    this.stopObserver();
    window.removeEventListener('resize', this.startObserver, false);
  },

  methods: {

    startObserver() {
      requestAnimationFrame(() => {
        if (this.adaptive.isDesktop) {
          return;
        }
        this.target = this.$refs.layout;

        if (!this.target) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.scrollableIsActive = !entry.isIntersecting;
          });
        }, {
          threshold: 1.0,
        });

        this.observer.observe(this.target);
      });
    },

    stopObserver() {
      if (this.observer && this.target) {
        this.observer.unobserve(this.target);
        this.observer = null;
      }
    },
  },
};
</script>

<style lang="scss">
.main-bar {
  position: relative;

  &__layout {
    position: relative;
    height: 56px;
  }

  &__content.container {
    @include stacking("sticky-header");
    position: absolute;
    top: 0;
    padding-top: 16px;
    padding-bottom: 16px;
    background: $white;

    &.scrollable {
      position: fixed;
    }
  }

  .logo {
    width: 120px;
    height: 24px;
  }

  .icon {
    color: $black;
  }

  .nav-toggler {
    margin-right: 16px;
  }

  .container {
    display: flex;

    > .link {
      display: none;
    }
  }
}

@include breakpoint("tablet") {
  .main-bar {
    &__content.container {
      &.scrollable {
        border-bottom: 1px solid $gray_lu;
        box-shadow: 0 4px 32px rgba(0, 0, 0, .08);
      }
    }
  }
}

@include breakpoint("desktop") {
  .main-bar {
    padding: 21px 0 11px;

    &__layout {
      display: none;
    }

    &__content.container {
      position: relative;
      padding-top: 0;
      padding-bottom: 0;
    }

    .logo {
      width: 204px;
      height: 30px;
    }

    .nav-toggler {
      display: none;
    }

    .container > .link {
      display: flex;
      margin-left: 34px;
      padding: 7px 0;
      color: $black;
      font-size: 14px;
      line-height: 16px;
    }

    .phone {
      white-space: nowrap;
    }
  }
}
</style>
